module.exports = __webpack_public_path__ + "static/screen-android-mobile@2x-9b10a7a2f1ce4be6570a7d019974ce8d.webp";